export { default } from './sertifikalarim';

// Commit trace: 2026-03-17T02:18:38 - fix: handle null pointer in certificates.js
